import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProjectsGridFiltered, ProjectDetails } from '../components/home/ProjectsSection';
import './Projects.css';

const Projects = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedProject, setSelectedProject] = useState(location.state?.selectedProject || null);
  const detailsRef = useRef(null);

  useEffect(() => {
    if (location.state?.selectedProject) {
      setSelectedProject(location.state.selectedProject);
    }
  }, [location.state]);

  useEffect(() => {
    if (selectedProject && detailsRef.current) {
      requestAnimationFrame(() => {
        detailsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }, [selectedProject]);

  return (
    <div className="projects-page">
      {selectedProject && (
        <div ref={detailsRef}>
          <ProjectDetails project={selectedProject} />
        </div>
      )}
      <ProjectsGridFiltered onProjectClick={project => setSelectedProject(project)} />
    </div>
  );
};

export default Projects;